import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import SectionHeading from '../components/SectionHeading';

const IMAGES = [
  {
    url: 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-08-01/8a8598f2b264.png',
    alt: 'Sealed copper handi with steam rising during dum cooking',
    span: 'md:col-span-2 md:row-span-2',
  },
  {
    url: 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-08-01/ef251881bf76.png',
    alt: 'Whole spices — cardamom, cinnamon, saffron, star anise — used in our biryani',
    span: '',
  },
  {
    url: 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-08-01/29603b24278d.png',
    alt: 'Plated dum biryani layered with basmati rice and fried onions',
    span: '',
  },
];

export default function Gallery() {
  return (
    <>
      <Helmet>
        <title>Gallery — Sealed Handis & Dum Cooking | Biryani2Go Omaha</title>
        <meta name="description" content="Behind-the-scenes gallery: sealed copper handis, fragrant spices, slow dum-cooked biryani preparation. See our process in Omaha & Council Bluffs." />
        <link rel="canonical" href="https://biryani2go.us/gallery" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://biryani2go.us"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Gallery",
                "item": "https://biryani2go.us/gallery"
              }
            ]
          }
        ` }} />
      </Helmet>

      <section className="bg-maroon py-16 md:py-20">
        <div className="max-w-screen-xl mx-auto px-5 md:px-8">
          <SectionHeading
            eyebrow="A Peek Inside"
            title="Behind the Scenes: Dum-Cooked Biryani Kitchen"
            description="Spice bowls, sealed handis, and the steam that makes it all worth the wait."
          />
        </div>
      </section>

      <section className="bg-surface py-16 md:py-24">
        <div className="max-w-screen-xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:auto-rows-[240px]">
            {IMAGES.map((img, i) => (
              <motion.div
                key={img.url + i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`rounded-[1.5rem] overflow-hidden card-tin ${img.span}`}
              >
                <img src={img.url} alt={img.alt} loading="lazy" className="w-full h-full object-cover" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
